import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ActivityService } from "../../services/activity.service";
import { Activity } from "../../models/activity.model";
import { generate, observe } from "fast-json-patch";
import { ToastrService } from "ngx-toastr";
import { EnvironmentConfig } from "../../../core/core";

declare const environment: EnvironmentConfig;

@Component({
  selector: "common-activity-card",
  templateUrl: "./activity-card.component.html",
  styleUrls: ["./activity-card.component.scss"],
})
export class ActivityCardComponent implements OnInit {
  @Input() activity: Activity;

  @Output() dismissed = new EventEmitter<Activity>();

  environment = environment;

  constructor(private activityService: ActivityService, private toastr: ToastrService) {}

  ngOnInit(): void {}

  dismiss() {
    if (this.activity.required) {
      return;
    }

    if (!confirm("Are you sure you want to dismiss?")) {
      return;
    }

    const observer = observe(this.activity);
    this.activity.status = "Dismissed";
    this.activity.completedDateTime = new Date().toDateString();
    const patch = generate(observer);

    this.activityService.jsonPatchWithPartitionKey(this.activity.id, patch, this.activity.accountId).subscribe(result => {
      this.dismissed.emit(this.activity);
      this.toastr.success("Task dismissed");
    });
  }
}
